export const trim = (value: string) => value.replace(/\s\s+/g, '');
export const oneWord = (value: string) => value.replace(/\s+/g, '');
export const numbersOnly = (value: string) => value.replace(/\D/g, '');
export const min = (min: number) => (value: string) =>
  Number(value) < min ? value.substring(0, value.length - 1) : value;
export const max = (max: number) => (value: string) =>
  Number(value) > max ? value.substring(0, value.length - 1) : value;
